import { getRoot } from '@invisr/mobx-state-tree'
import { flow } from '@invisr/mobx-state-tree'
export const withoutPatch = (node, fn) => {
  let root = getRoot(node)
  if(!root) root = node
  if(root.undoManager) {
    return root.undoManager.withoutUndo(fn)
  } 
  return fn()
}

export const withoutPatchFlow = (node, fn) => {
  let root = getRoot(node)
  if(!root) root = node
  if(root.undoManager) {
    return root.undoManager.withoutUndoFlow(fn)()
  } 
  return flow(fn)()  
}
